import type { FieldValues, UseFormProps } from 'react-hook-form'
// eslint-disable-next-line no-restricted-imports
import { useForm as useFormOriginal } from 'react-hook-form'

export const useForm = <
  TFormValues extends FieldValues = FieldValues,
  TContext extends object = object,
>(
  props?: UseFormProps<TFormValues, TContext>
) =>
  useFormOriginal<TFormValues, TContext>({
    mode: props?.mode ?? 'onBlur',
    reValidateMode: props?.reValidateMode ?? 'onChange',
    ...props,
  })
